
export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    const { token } = useAuth()

    const customFetch = $fetch.create({
        baseURL: config.public.apiBaseUrl as string,
        onResponseError({ response, error }) {
            const status = response.status
            const data = response._data

            throw {
                status,
                message: data?.detail || data?.message || 'Произошла ошибка при выполнении запроса',
                data
            }
        }
    })

    return {
        provide: {
            apiFetch: async (path: string, opts: any = {}) => {
                // Не изменяем оригинальный объект
                const options = { ...opts }
                
                // Установка заголовков
                options.headers = options.headers || {}
                
                // Получение актуального токена и добавление его в заголовки
                if (token.value) {
                    options.headers = {
                        ...options.headers,
                        Authorization: `${token.value}`
                    }
                } //else {
                    //console.warn('No token available for request to:', path)
                //}

                // Выполнение запроса
                return customFetch(path, options)
            }
        }
    }
}) 